import React from 'react'

import { Button as AntButton } from 'antd'

import { ANT_SIZE_MAP, VARIANT_TO_ANT_TYPE } from './constants'
import { useStyles } from './styles'
import type { ButtonProps } from './types'

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'default',
  danger,
  iconLeft,
  iconRight,
  children,
  className,
  loading,
  ...rest
}) => {
  const { styles, cx } = useStyles()

  const isIconOnly = !children && !!(iconLeft || iconRight)

  const variantClass =
    variant === 'secondary'
      ? styles.secondary
      : variant === 'tertiary'
      ? styles.tertiary
      : undefined

  const iconClass =
    variant === 'link-secondary' ? styles.linkSecondaryIcon : undefined

  const iconOnlyClass = isIconOnly
    ? size === 'large'
      ? styles.iconOnlyLarge
      : size === 'small'
      ? styles.iconOnlySmall
      : styles.iconOnlyDefault
    : undefined

  return (
    <AntButton
      type={VARIANT_TO_ANT_TYPE[variant]}
      size={ANT_SIZE_MAP[size]}
      danger={danger}
      loading={loading}
      className={cx(styles.root, variantClass, iconOnlyClass, className)}
      {...rest}
    >
      {!loading && iconLeft && (
        <span className={cx(styles.iconWrapper, iconClass)}>{iconLeft}</span>
      )}
      {children}
      {!loading && iconRight && (
        <span className={cx(styles.iconWrapper, iconClass)}>{iconRight}</span>
      )}
    </AntButton>
  )
}
